module.exports = __webpack_public_path__ + "img/93c079c.jpg";